import { SVGIconComponent } from './types';

export const LockerM: SVGIconComponent = ({ className, color, style }) => (
  <svg
    version="1.0"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 25 26"
    xmlSpace="preserve"
    style={{ color, ...style }}
    className={className}
  >
    <g id="Locker-Sizes_x2F_locker-M">
      <g id="locker-M">
        <g id="M">
          <path
            id="path-1_00000091012691934635728020000017543685336655821730_"
            fillRule="evenodd"
            clipRule="evenodd"
            fill="currentColor"
            d="M12.8,0l11.5,5.5c0.2,0.1,0.3,0.3,0.3,0.5
				l0,10.8c0,0.2-0.1,0.3-0.2,0.4l-11.6,8.4l0,0c0,0,0,0,0,0l0,0c0,0-0.1,0-0.1,0.1c0,0,0,0,0,0c0,0,0,0-0.1,0c0,0,0,0,0,0
				c0,0,0,0-0.1,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0-0.1,0c0,0,0,0,0,0c0,0,0,0-0.1,0
				c0,0,0,0,0,0l-12-6.9C0.1,18.7,0,18.5,0,18.3V7.9c0-0.3,0.2-0.5,0.4-0.5l11.9-7.3C12.5,0,12.7,0,12.8,0z M1,8.8V18l11,6.3v-9.4
				L1,8.8z M23.6,7.2L13,14.8v9.4l10.6-7.6V7.2z M12.6,1.1L1.5,7.9L12.4,14l10.7-7.8L12.6,1.1z"
          />
        </g>
      </g>
      <polygon
        id="M_00000089541938814768008540000014374559712830911654_"
        fill="currentColor"
        points="10,10.6 10,6.7 10.1,6.7 11.6,10.4 
		12.4,10.4 13.9,6.7 14,6.7 14,10.6 14.9,10.6 14.9,5 13.7,5 12,9.1 12,9.1 10.3,5 9.1,5 9.1,10.6 	"
      />
    </g>
  </svg>
);
